import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const text: AdminBlockTypeAttribute = {
  label: 'Show text',
  key: 'text',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default text;
